<template>
    <div class="resources-content">
        <el-scrollbar class="resources-scroll">
            <div class="select-wrapper">
                <div>
                    <div class="select-left">
                        <span class="text">资源分类</span>
                        <el-cascader v-model="specializedValue"
                                     style="width: 300px"
                                     :props="keyObj"
                                     :options="specializedList"
                                     @change="changeResourcesClass"
                                     clearable
                                     placeholder="请选择分类"
                                     class="resources-cascader">
                        </el-cascader>
                    </div>
                    <div class="type-wrapper">
                        <div class="type-name">资源类型</div>
                        <div class="type-list">
                            <div class="type-item" :class="{current:typeCurrent === 0}" @click="toggleTypeCur(0)">全部
                            </div>
                            <div class="type-item" :class="{current:typeCurrent === resourcesItem.id}"
                                 v-for="resourcesItem in resourcesTypeList"
                                 :key="resourcesItem.id"
                                 @click="toggleTypeCur(resourcesItem.id)">
                                {{resourcesItem.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--        <div class="table-wrapper">-->
            <!--自己写的表格-->
            <div class="table-wrapper">
                <!--自己写的表格-->
                <div class="d-table">
                    <div class="d-thead">
                        <div class="d-tr">
                            <div class="d-th-80">
                                <div class="cell">类型</div>
                            </div>
                            <div class="d-th">
                                <div class="cell">资源标题</div>
                            </div>
                            <div class="d-th">
                                <div class="cell">简介</div>
                            </div>
                            <div class="d-th-100">
                                <div class="cell">时长/页数</div>
                            </div>
                            <div class="d-th-80">
                                <div class="cell">操作</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-tbody">
                        <el-scrollbar style="height: 100%">
                            <draggable :list="resourcesTableData"
                                       :group="{name: 'resources', pull: 'clone', put: false }"
                                       :sort="false" :move="onMove" @end="onEnd">
                                <div class="d-tr" v-for="(item, index) in resourcesTableData" :key="index">
                                    <div class="d-td-80 cell" v-if="mode === '0'">
                                        <el-checkbox v-model="checkedList" :label="item.id" :disabled="!curIndex">
                                            {{item.file_ext}}
                                        </el-checkbox>
                                    </div>
                                    <div class="d-td-80" v-else>
                                        <div class="cell">{{item.file_ext}}</div>
                                    </div>
                                    <div class="d-td resourceTit">
                                        <div class="cell">{{item.title}}</div>
                                    </div>
                                    <div class="d-td">
                                        <div class="cell">{{item.intro}}</div>
                                    </div>
                                    <div class="d-td-100">
                                        <div class="cell">{{item.page_time}}</div>
                                    </div>
                                    <div class="d-td-80">
                                        <el-link type="primary" :underline="false" @click="previewResources(item)">预览
                                        </el-link>
                                    </div>
                                </div>
                            </draggable>
                        </el-scrollbar>
                    </div>
                </div>
                <el-pagination class="pages-right" style="margin: 20px 0;text-align: center"
                               :current-page="resourcePages.currentPageNum"
                               :page-size="resourcePages.eachPageNum"
                               layout="prev, pager, next, jumper"
                               :total="resourcePages.total"
                               @current-change="resourcePagesCurrentChange">
                </el-pagination>
                <div class="one-import" v-if="mode === '0' && curIndex">
                    <el-button type="primary" size="small" @click="selectMaterials">一键添加</el-button>
                </div>
            </div>
            <div class="video-dialog" v-if="showDialogMp4">
                <i class="iconfont close-icon" @click="closeDialogMp4">&#xe8e7;</i>
                <div class="video-content">
                    <video width="100%" height="auto" :src="videoSrc" controls="true" controlslist="nodownload"></video>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {resourceType, cate, resource} from '@/utils/apis.js'
    import draggable from 'vuedraggable';
    import _ from 'underscore';

    export default {
        name: "MaterialResource",
        props: ['mode', 'curIndex', 'child'],
        components: {
            draggable
        },
        data() {
            return {
                //资源分类列表
                specializedValue: [],
                specializedList: [],
                keyObj: {
                    label: 'name',
                    value: 'id',
                    children: 'children'
                },
                //资源类型
                resourcesTypeList: [],
                typeCurrent: 0,
                //资源库列表
                resourcesTableData: [],
                //分页
                resourcePages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                showDialogMp4: false,
                videoSrc: '',
                formLabelWidth: '120px',
                rules: {
                    resource_title: [
                        {required: true, message: '请输入资源标题', trigger: 'blur'}
                    ],
                    resource_content: [
                        {required: true, message: '请输入简介', trigger: 'blur'}
                    ],
                    file_preview_path: [
                        {required: true, message: '请选择文件', trigger: 'change'}
                    ],
                    resourcesValue: [
                        {required: true, message: '请选择资源类型', trigger: 'change'}
                    ],
                },
                editCurrentIndex: null,
                uploadDialogStatus: false,
                //资源类型
                resTypeProp: {
                    label: 'resource_type_name',
                    value: 'resource_type_id',
                    children: 'children'
                },
                resourcesType: [],
                checkedList: []
            }
        },
        created() {
            this.getSpecializedList();
            this.getResourcesType();
            this.getResourcesList();
        },
        methods: {
            initChecks() {
                this.checkedList = [];
            },
            //资源分类列表
            getSpecializedList() {
                let param = {
                    type: '2'
                }
                cate(param).then((res) => {
                    this.specializedList = res.data;
                }, (err) => {
                    console.log(err);
                })
            },
            //选择的分类
            changeResourcesClass() {
                this.getResourcesList();
            },
            selectMaterials(val) {
                let arrTmp = _.filter(this.resourcesTableData, (item) => {
                    return this.checkedList.indexOf(item.resource_id) !== -1;
                });
                arrTmp = _.map(arrTmp, (item) => {
                    let obj = {};
                    obj.name = item.name;
                    obj.id = item.id;
                    obj.child = [];
                    obj.type = 1;
                    return obj
                })
                this.$emit('rematerials', arrTmp);
                this.initChecks();
            },
            //资源类型
            getResourcesType() {
                resourceType().then((res) => {
                    this.resourcesTypeList = res.data;
                }, (err) => {
                    console.log(err);
                })
            },
            //选择的资源类型
            toggleTypeCur(id) {
                this.typeCurrent = id;
                this.getResourcesList();
            },
            changeResourceType(val) {
                if (val.length === 2) {
                    this.editingRow.resourcesValue = val[0];
                    this.editingRow.material_type_id = val[1];
                } else {
                    this.editingRow.resourcesValue = val;
                }
            },
            //获取资源库列表
            getResourcesList() {
                let param = {
                    page: this.resourcePages.currentPageNum,
                    limit: this.resourcePages.eachPageNum,
                }
                if (this.typeCurrent) {
                    param.type = this.typeCurrent;
                }
                if (this.specializedValue.length > 0) {
                    param.category_id = this.specializedValue[this.specializedValue.length - 1];
                }
                resource(param).then((res) => {
                    this.resourcesTableData = _.map(res.data.list, (item) => {
                        item.material_type = 1
                        item.resource_id = item.id
                        item.type = 1;
                        item.name = item.title
                        item.child = [];
                        return item;
                    });
                    this.resourcePages.total = res.data.total;
                }, (err) => {
                    console.log(err);
                })
            },
            previewResources(row) {
                if (row.file_ext === 'mp4' || row.file_ext === 'MP4') {
                    this.showDialogMp4 = true;
                    this.videoSrc = row.file_preview_path;
                } else if (row.file_ext === 'pdf' || row.file_ext === 'PDF') {
                    // let url = process.env.NODE_ENV === 'development' ? this.$config.baseUrl : '';
                    // window.open(url + this.$api.pdfPreview + row.resource_id);
                    window.open(localStorage.getItem('hosturl') + 'pdf/' + row.id);
                }
            },
            closeDialogMp4() {
                this.showDialogMp4 = false
            },
            //分页
            resourcePagesCurrentChange(val) {
                this.resourcePages.currentPageNum = val;
                this.getResourcesList()
            },
            onMove(evt) {

            },
            onEnd(evt) {

            }
        }
    }
</script>

<style lang="scss" scoped>
    .resources-content {
        display: flex;
        flex-direction: column;
        height: 100%;

        .resources-scroll {
            height: 100%;

            ::v-deep .el-scrollbar__view {
                padding: 0 20px;
            }
        }
    }

    .select-wrapper {

        .select-left {
            display: flex;
            align-items: center;

            .text {
                font-size: 14px;
                color: #333333;
                margin-right: 10px;
            }

            .resources-cascader {
                width: 420px;

                ::v-deep .el-input__inner {
                    border-radius: 0;
                }
            }
        }

        .select-btn {
            i {
                font-size: 12px;
                margin-right: 5px;
            }
        }
    }

    .type-wrapper {
        display: flex;
        align-items: center;
        margin-top: 18px;

        .type-name {
            line-height: 30px;
            color: #333;
            margin-right: 10px
        }

        .type-list {
            .type-item {
                display: inline-block;
                padding: 4px 10px;
                border-radius: 2px;
                font-size: 14px;
                border: 1px solid #D2D2D2;
                background-color: #fff;
                cursor: pointer;
                color: #666;
                transition: all .3s ease-in;
                margin-right: 10px;

                &.current {
                    color: #fff;
                    background: #F23B2F;
                    border: 1px solid #F23B2F;
                }

                &:hover {
                    background: #F23B2F;
                    border: 1px solid #F23B2F;
                    color: #fff;
                }
            }
        }
    }

    .table-wrapper {
        position: relative;
        padding: 20px 0;

        .table-content {
            .img-thumb {
                width: 60px;
                height: 60px;
                overflow: hidden;

                img {
                    display: block;
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }

        .d-table {
            width: 100%;
            border: 1px solid #EBEEF5;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            flex: 1;
            max-width: 100%;
            font-size: 14px;
            color: #606266;
            background-color: #FFF;

            .d-tbody {
                height: 497px;

                ::v-deep .el-scrollbar__view {
                    padding: 0;
                }
            }

            .d-tr {
                height: 53px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: move;

                .d-th, .d-th-80, .d-th-100 {
                    background-color: rgb(245, 247, 250);
                }

                .d-th-80, .d-th-100, .d-td-80, .d-td-100, .d-th, .d-td {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-bottom: 1px solid #EBEEF5;
                }

                .d-th, .d-td {
                    flex: 1;
                    justify-content: flex-start;
                    padding: 0 10px;
                    align-items: center;
                }

                .d-th-80, .d-td-80 {
                    width: 80px;
                }

                .d-th-100, .d-td-100 {
                    width: 100px;
                }

                .d-td-right {
                    border-right: none;
                }
            }
        }

        .one-import {
            position: absolute;
            bottom: 25px;
            left: 10px;
        }
    }

    .video-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 9;

        .close-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 30px;
            width: 30px;
            height: 30px;
            line-height: 1;
            background: rgba(0, 0, 0, .7);
            color: #fff;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                color: #409EFF;
            }
        }

        .video-content {
            width: 50%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: 3px solid #111;

            video {
                outline: none;
                display: block;
            }
        }
    }

</style>